import React from 'react';
import Link from 'next/link';
import SaneImage from '../sanity/sane-image';
import { Heading, Text, Box, Flex, Grid, GridItem } from '@chakra-ui/react';
import { LayoutContainer } from '@components/common';

type Props = {
  investors: Array<{
    name: string;
    picture: string;
    url: string;
    role: string;
  }>;
};

export const Investors = ({ investors }: Props) => (
  <LayoutContainer>
    <Flex justifyContent="center" alignItems="center" mx={{ lg: 16 }}>
      <Box pos="relative">
        <Heading size="h2" mb={12} textAlign="center">
          Proudly Supported <br></br>
          <Heading color="primary.500">By Developer Tools Experts.</Heading>
        </Heading>
      </Box>
    </Flex>

    <Grid
      templateColumns={{
        base: 'repeat(1, 1fr)',
        md: 'repeat(2, 1fr)'
      }}
      gap={8}
    >
      {investors.slice(0, 2).map(investor => (
        <GridItem key={investor.name}>
          <Box
            key={investor.name}
            bg="white"
            p="24px"
            display={'flex'}
            flexDir="row"
            alignItems="center"
            borderRadius="8px"
            pos="relative"
          >
            {investor.picture && (
              <SaneImage
                alt={investor.name}
                src={investor.picture}
                height={72}
                width={72}
              />
            )}
            <Box p="16px">
              <Text mb={1} fontWeight="semibold">
                {investor.name}
              </Text>
              {investor.url ? (
                <Link
                  legacyBehavior
                  href={`https://${investor.url}`}
                  target="_blank"
                  passHref
                >
                  <Box as="a">{investor.url}</Box>
                </Link>
              ) : (
                <Text>{investor.role}</Text>
              )}
            </Box>
          </Box>
        </GridItem>
      ))}
    </Grid>

    <Grid
      templateColumns={{
        base: 'repeat(1, 1fr)',
        md: 'repeat(3, 1fr)'
      }}
      gap={8}
      mt={8}
    >
      {investors.slice(2, 8).map(investor => (
        <GridItem key={investor.name}>
          <Box
            key={investor.name}
            bg="white"
            display={'flex'}
            flexDir="row"
            alignItems="center"
            rounded="md"
            minH="9vh"
            pos="relative"
          >
            <Box p="16px">
              <Text mb={1} fontWeight="semibold">
                {investor.name}
              </Text>
              {investor.url ? (
                <Link
                  legacyBehavior
                  href={`https://${investor.url}`}
                  target="_blank"
                  passHref
                >
                  <Box as="a">{investor.url}</Box>
                </Link>
              ) : (
                <Text>{investor.role}</Text>
              )}
            </Box>
          </Box>
        </GridItem>
      ))}
    </Grid>
  </LayoutContainer>
);

export default Investors;
